module.exports = __webpack_public_path__ + "static/media/Shape.689cda42.svg";